<template>
  <ValidationProvider :name="radioName" :rules="rules" v-slot="{ errors }" class="field__item">
    <span :class="{'form__notice--active': errors.length > 0}" class="form__notice text--red">{{ errors[0] }}</span>
    <div class="field__item--checkbox">
      <div class="field__item--label">
        <label>{{ radioName }}</label>
        <label v-for="(item, index) in radio" :key="index" class="field__item--radio">
          <input :id="item.value" :name="radioName" :checked="value === item.value" :value="value" @change="updateInput(item.value)"  type="radio" />
          <span>{{ item.label }}</span>
          <div class="field__item--check"></div>
        </label>
      </div>
    </div>
  </ValidationProvider>
</template>

<style lang="scss">
</style>

<script>
export default {
  name: 'Radio',
  props: {
    radio: Array,
    radioName: String,
    rules: String,
    type: String,
    value: [String, Number],
    classes: {},
    required: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    updateInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>
